var OSS = require('./browser/client');
OSS.Buffer = require('buffer').Buffer;
OSS.co = require('co');
OSS.urllib = require('../shims/xhr');

module.exports = OSS;



//////////////////
// WEBPACK FOOTER
// ./~/ali-oss/lib/browser.js
// module id = 327
// module chunks = 0 1